module.exports = __webpack_public_path__ + "img/4.ce7072d1.png";